
/*
 * @Author: panweikang
 * @Date: 2024-01-04 15:23:35
 * @LastEditTime: 2024-07-24 14:20:17
 * @Description:
 */
import './Detail.scss'
import React, { useEffect, useState } from 'react'
import logo from '../../static/report/logo.png'
import tiefenActivePng from '../../static/pay/tiefen_active.png'
import tiefenPng from '../../static/pay/tiefen.png'
import lightPng from '../../static/pay/light.png'
import boughtPng from '../../static/pay/bought.png'
import tipsPng from '../../static/pay/tips.png'

import ptPng from '../../static/YearMiddleReport2024/GroupBuying/pt.png'
import jjPng from '../../static/YearMiddleReport2024/GroupBuying/jj.png'
import jjBlackPng from '../../static/YearMiddleReport2024/GroupBuying/jj_black.png'
import sqPng from '../../static/YearMiddleReport2024/GroupBuying/sq.png'
import selectionCSJPng from '../../static/YearMiddleReport2024/report/selectionCSJ.png'
import sanrenPng from '../../static/YearMiddleReport2024/detail/sanren.png'
import pintuanPng from '../../static/YearMiddleReport2024/detail/pintuan.png'
import weixinPng from '../../static/YearMiddleReport2024/detail/weixin.png'
import wenhaoPng from '../../static/YearMiddleReport2024/detail/wenhao.png'
import mianpinPng from '../../static/YearMiddleReport2024/detail/mianpin.png'
import jiasu2Png from '../../static/YearMiddleReport2024/detail/jiasu2.png'
import jiasuPng from '../../static/YearMiddleReport2024/detail/jiasu.png'
import jiantouSvg from '../../static/YearMiddleReport2024/detail/jiantou.svg'

import Decimal from 'decimal.js'

import { Avatar, Image, Button, Toast } from 'antd-mobile'
import { MailOutline } from 'antd-mobile-icons'

// import { regionImage, regionDes } from './constants'
import {
  wxJsapiPayApi,
  getTeamWorkDetailApi,
} from '../../api/yearEndReportApi'

import clonedeep from 'lodash.clonedeep'
import { useMemo } from 'react'

import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import wxConfig, { wxconfigNew } from '../../utils/wxConfig'

// import MShare from '../../components/MShare/index'
import MHead from '../../components/MHead/index'
import Barrage from './Barrage'
import { yearMiddle2024 } from './constants'
import { useImmer } from 'use-immer'
import { countdown } from '../../utils/utils'

let shareList = [
  {
    title: '想不想成为那个特别的伙伴？',
    desc: '那个与我并肩作战，共同抢购瑞莱博报告的超级英雄！'
  },
  {
    title: '你准备好加入这场智慧的冒险了吗？',
    desc: '一起携手，将瑞莱博2024年上半年度报告收入囊中——这绝对是一笔超值交易！'
  },
  {
    title: '这次，我锁定你了！',
    desc: '你，就是我们瑞莱博2024年上半年度报告团购梦想的最后一块拼图！'
  },
  {
    title: '来吧，和我一起组建最强拼团小分队',
    desc: '半价拿下瑞莱博2024年上半年度报告！'
  },
  {
    title: '知识的种子已经撒下，你愿意成为滋润它的甘露吗？',
    desc: '加入我们的团购，让瑞莱博报告成为我们共同成长的见证！'
  },
  {
    title: '奔赴卓越之路，你怎能缺席？',
    desc: '这不仅仅是一次瑞莱博2024年上半年度报告的购买，更是一次知识的盛宴！'
  },
  {
    title: '紧急呼叫所有物流地产界的知识探险家！',
    desc: '团购瑞莱博报告的航班即将起飞，你的座位已经预留好了，快来登机吧！'
  },
]

let timer = null
let Index = () => {
  // document.title = '分享/付费'
  document.title = '拼团享优惠'
  let navigate = useNavigate()
  const { id: clusterId } = useParams()
  const [loaded, setLoaded] = useState(false)
  const [userInfo, setUserInfo] = useImmer(JSON.parse(sessionStorage.getItem('userInfo') || '{}'))


  function getRandomElementFromArray(arr) {
    // 计算数组的长度
    const length = arr.length;
    // 生成一个0到length-1之间的随机索引
    const randomIndex = Math.floor(Math.random() * length);
    // 返回随机索引对应的数组元素
    return arr[randomIndex];
  }

  useEffect(() => {
    const randomElement = getRandomElementFromArray(shareList)
    console.log(randomElement)
    wxconfigNew(
      {
        ...randomElement,
        link: `${window.location.origin}/rlb/YearMiddleReport2024/GroupBuying?clusterId=${clusterId}`,
        imgUrl: `${window.location.origin}/static/share.png`,
      },
      {
        ...randomElement,
        link: `${window.location.origin}/rlb/YearMiddleReport2024/GroupBuying?clusterId=${clusterId}`,
        imgUrl: `${window.location.origin}/static/share.png`,
      }
    )
    return () => {
      wxConfig()
    }
  }, [])

  useEffect(() => {
    if (clusterId) {
      getTeamWorkDetail()
    }
    return () => {
      clearInterval(timer);
    }
  }, [clusterId])

  const [users, setUsers] = useState([])
  const [status, setStatus] = useState(null)
  const [products, setProducts] = useState([])
  let [allUserCount, setAllUserCount] = useState(0)
  let [teamedUserCount, setTeamedUserCount] = useState(0)
  const [validTime, setValidTime] = useState('')
  let originalPrice = products.reduce((acc, obj) => {
    return acc.plus(Decimal(obj.originalPrice));
  }, Decimal(0)).toNumber();
  let fanPrice = products.reduce((acc, obj) => {
    return acc.plus(Decimal(obj.fanPrice));
  }, Decimal(0)).toNumber();

  const hasFree = users.some(item => !!item?.isFree)

  let neededNumber = (() => {
    let cz = Decimal(allUserCount).minus(Decimal(teamedUserCount))
    return hasFree ? cz.minus(Decimal(1)).toNumber() : cz.toNumber()
  })()

  const getTeamWorkDetail = async () => {
    try {
      setLoaded(true)
      let { data } = await getTeamWorkDetailApi({
        clusterId,
        openId: userInfo.openId
      })
      setValidTime(data.validTime)
      timer = countdown(data.validTime, (time) => {
        setValidTime(time)
      })
      setUsers(data.users)
      // setStatus(3)
      setStatus(data.status)
      setProducts(data.products)
      setAllUserCount(data.allUserCount)
      setTeamedUserCount(data.teamedUserCount)
    } catch (error) {
      console.log(error)
    } finally {
      setLoaded(false)
    }
  }

  const goCheats = () => {
    navigate(`/rlb/YearMiddleReport2024/Cheats/${clusterId}`)
  }

  const originalPriceBuy = async () => {
    let wxJsapiPayParams = {
      'openId': userInfo.openId,
      'productIds': products.map(product => product.productId),
      'price': Decimal(originalPrice).minus(Decimal(fanPrice)).toNumber(),// 补差价
      payType: 2,
      isCancelTeamPay: true,
      clusterId,
    }
    console.log(wxJsapiPayParams)
    debugger
    let res = await wxJsapiPayApi(wxJsapiPayParams)
    if (res.status === 200) {
      payParams = {
        'appId': res.data.appId,
        'timeStamp': res.data.timeStamp,
        'nonceStr': res.data.nonceStr,
        'package': res.data.packAge,
        'signType': res.data.signType,
        'paySign': res.data.paySign,
      }

      console.log('payParams', payParams)
      wxPay()
    } else {
      Toast.show(res.msg)
    }
  }

  let payParams = {}
  function onBridgeReady() {
    console.log(payParams)
    // eslint-disable-next-line no-undef
    WeixinJSBridge.invoke(
      'getBrandWCPayRequest',
      {
        ...payParams,
      },
      function (res) {
        console.log('getBrandWCPayRequest', res)
        if (res.err_msg === 'get_brand_wcpay_request:ok') {
          navigate('/rlb/YearMiddleReport2024/GroupRecords')
        }
      }
    )
  }

  function wxPay() {
    if (typeof WeixinJSBridge == 'undefined') {
      if (document.addEventListener) {
        document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false)
      } else if (document.attachEvent) {
        document.attachEvent('WeixinJSBridgeReady', onBridgeReady)
        document.attachEvent('onWeixinJSBridgeReady', onBridgeReady)
      }
    } else {
      onBridgeReady()
    }
  }

  const goViewReport = () => {
    navigate('/rlb/YearEndReport/bought')
  }

  const AnotherGroup = () => {
    navigate('/rlb/YearMiddleReport2024/groupBuying')
  }

  return (

    <div className="YearMiddleReport2024Detail page">
      <MHead />
      <div className="pageContent">
        {
          status === 1 && <div className='detailTip'>
            <Image
              src={jiantouSvg}
              width={52}
              height={52}
              fit="cover"
              className='image'
            />
            <div>
              <p>点击右上角 ... </p>
              <p>邀请好友拼团享优惠</p>
            </div>
          </div>
        }

        {
          status === 1 && <div className='detailInfo'>
            <h6>拼团进行中</h6>
            {/* <h6>未成团</h6> */}
            <div>
              <p>已发起拼团</p>
              <p>快邀请好友成团吧</p>
              {/* <p>钱款已原路退回支付方</p> */}
              {/* <p>报告已经自动发送至填写的邮箱地址，请注意查收</p> */}

            </div>
          </div>
        }

        {
          status === 3 && <div className='detailInfo'>
            <h6>未成团</h6>
            <div>
              <p>钱款已原路退回支付方</p>
            </div>
          </div>
        }
        {
          status === 2 && <div className='detailInfo'>
            <h6>拼团成功</h6>
            <div>
              <p>报告已经自动发送至填写的邮箱地址，请注意查收</p>
            </div>
          </div>
        }

        <div className='detailIntroduce'>
          <div>
            <Image
              src={weixinPng}
              width={16}
              height={16}
              fit="cover"
              className='image'
            />
            <p>下单拼团</p>
          </div>
          <div>
            <Image
              src={pintuanPng}
              width={16}
              height={16}
              fit="cover"
              className='image'
            />
            <p>邀请好友拼团</p>
          </div>
          <div>
            <Image
              src={sanrenPng}
              width={16}
              height={16}
              fit="cover"
              className='image'
            />
            <p>3人成团看报告</p>
          </div>
        </div>

        <div className='groupDetail'>
          <div className='groupDetailPerson'>
            {
              users?.map((item, index) => {
                return <div key={index}>
                  {
                    item ? <>
                      {
                        item.isFree ?
                          <Image
                            src={mianpinPng}
                            width={56}
                            height={56}
                            fit="cover"
                            className='image'
                          /> :
                          <>
                            <Image
                              src={item.headImgUrl}
                              style={{ borderRadius: 28 }}
                              width={56}
                              height={56}
                              fit="cover"
                              className='image'
                            />
                            {
                              item.isLeader && <span>团长</span>
                            }
                          </>
                      }
                    </> :
                      <Image
                        src={wenhaoPng}
                        width={56}
                        height={56}
                        fit="cover"
                        className='image'
                      />
                  }

                </div>
              })
            }

          </div>
          {/* 状态:1=待成团，2=拼团成功，3=拼团失败，4=取消拼团 */}
          {
            status === 1 && <div className='groupDetailTime'>
              还差<span>{neededNumber}</span>人拼团成功<span>{validTime}</span>后结束
            </div>
          }

          {
            status === 2 && <div className='groupDetailTime success'>
              拼团成功
            </div>
          }

          {
            status === 3 && <div className='groupDetailTime fail'>
              拼团失效
            </div>
          }


          {
            status === 1 && <div className='groupDetailBtn'>
              <div className='groupDetailBtn1' onClick={originalPriceBuy}>原价购买 取消拼团</div>
              {
                hasFree ? <div className='groupDetailBtn2 shared'>
                  <Image
                    src={jiasu2Png}
                    width={31}
                    height={29}
                    fit="cover"
                    className='image'
                  />
                  <p>
                    <span>邀请好友助力</span>
                    <span>立刻加速成团</span>
                  </p>
                </div>
                  : <div className='groupDetailBtn2' onClick={goCheats}>
                    <Image
                      src={jiasuPng}
                      width={31}
                      height={29}
                      fit="cover"
                      className='image'
                    />
                    <p>
                      <span>分享至微信群/朋友圈 </span>
                      <span>立刻加速成团</span>
                    </p>
                  </div>
              }
            </div>
          }

          {
            status === 2 && <div className='groupDetailBtn'>
              <div className='groupDetailBtn3' onClick={goViewReport}>
                查看或下载报告
              </div>
            </div>
          }

          {
            status === 3 && <div className='groupDetailBtn'>
              <div className='groupDetailBtn1' onClick={originalPriceBuy}>原价购买</div>
              <div className='groupDetailBtn3' onClick={AnotherGroup}>
                再开一团
              </div>
            </div>
          }

        </div>

        <div className="payList">
          <h6>拼团详情</h6>
          {
            products.map((item, index) => {
              return <div className="listItem" key={index}>
                <Image
                  className="image"
                  src={yearMiddle2024.find(p => p.regionId === item.productId).coverImage}
                  width={105}
                  height={57}
                  fit="cover"
                />
                <div className="listItemMiddle">
                  <div className="listTitle">
                    <span>{item.productName}</span>
                  </div>
                  <div className="listTxt">
                    {/* todo */}
                    <p>{yearMiddle2024.find(p => p.regionId === item.productId).sellingpPoint}</p>
                  </div>
                </div>
              </div>
            })
          }
        </div>
      </div>
    </div >
  )
}

export default Index
